// extracted by mini-css-extract-plugin
export default {"input__container":"Input_input__container__fvWAc","label":"Input_label__UFqAR","input":"Input_input__Qmn3z"};